import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SbBooleanToggle, SbBooleanToggleModel, SbBooleanToggleViewMode } from 'src/app/services/global/global-interfaces';

@Component({
  selector: 'sb-boolean-toggles',
  templateUrl: './sb-boolean-toggles.component.html',
  styleUrls: ['./sb-boolean-toggles.component.scss'],
  standalone: false,
})
export class SbBooleanTogglesComponent {
  @Input() toggles: SbBooleanToggleModel[] = [];

  @Input() viewMode: SbBooleanToggleViewMode = 'default';

  @Input() translateLabels: boolean = true;

  @Output() toggleChange: EventEmitter<SbBooleanToggle> = new EventEmitter<SbBooleanToggle>();

  constructor() {}

  onToggleChange(pId: string, $event: boolean) {
    this.toggleChange.emit({ id: pId, value: $event });
  }
}
